import React, { useEffect, useState } from "react";
import moment from "moment-timezone";
//* Used from July 1st
// import DateRangePicker from "@wojtekmaj/react-daterange-picker";
// import "@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css";
// import { ReactComponent as CalendarIcon } from "../../../../assets/icons/calendar.svg";
//* Used before July 1st
import { DatePicker, DateRangePicker } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import "react-calendar/dist/Calendar.css";
import { ReactComponent as ShareIcon } from "../../../../assets/icons/ShareIcon.svg";
import Select from "react-select";
import {
  assesmentsToSelectYouth,
  dateFilters,
  notesFilter,
  assesmentsToSelectAdult,
} from "../../../../constants/constants";


const FilteredComponent = ({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  showNotesDD = false,
  showBillingNotes = false,
  showAssessmentFilter = false,
  selectedAssessment = null,
  setSelectedAssessment = null,
  showCareGiverFilter = false,
  selectedCareGiver = null,
  setSelectedCareGiver = null,
  showDateFilter = false,
  dateFilterValue = null,
  setDateFilterValue = null,
  //notesFilter,
  notesFilterValue = null,
  setNotesFilterValue = null,
  journalDateFilter = false,
  journalFilterValue = null,
  setJournalFilterValue = null,
  notesDownloadMode = null,
  setNotesDownloadMode = null,
  setBillingsFilter = null, 
  billingNotesFilter = null,
}) => {
  const [selectedMonth, setSelectedMonth] = useState(null);

  let assesmentsToSelect = [
    {
      label: "All Assessments",
      value: "allAssessments",
    },
    ...assesmentsToSelectAdult,
  ];
  if (process.env.REACT_APP_DASHBOARD_TYPE === "youth") {
    //depending on youth or adult populate the dropdown
    assesmentsToSelect = [];
    assesmentsToSelect = [
      {
        label: "All Assessments",
        value: "allAssessments",
      },
      ...assesmentsToSelectYouth,
    ];
  }
  const careGiverOptions = [
    {
      label: "All",
      value: "all",
    },
    {
      label: "Caregiver",
      value: "caregiver",
    },
    {
      label: "Patient",
      value: "patient",
    },
  ];

  return (
    <div
      className="w-100 d-flex justify-content-between"
      style={{ gap: "15px", margin: "0px" }}
    >
      <div
        className="d-flex"
        style={{ margin: "0px", padding: "0px", width: "100%", gap: "15px" }}
      >

        {showNotesDD && (
          <div style={{ width: "15%" }}>
            <Select
              styles={{
                control: (baseStyles) => ({
                  ...baseStyles,
                  border: "1px solid #CBD5E1",
                  boxShadow: "0px 4px 3px rgba(232, 237, 242, 0.65)",
                  borderRadius: "8px",
                  padding: "5px",
                }),
              }}
              components={{
                IndicatorSeparator: () => null,
              }}
              placeholder="Select"
              classNamePrefix="select"
              name="notes"
              options={notesFilter}
              value={notesFilterValue}
              onChange={(e) => {
                setNotesFilterValue(e);
              }}
            />
          </div>
        )}

        {showAssessmentFilter && (
          <div style={{ width: "15%" }}>
            <Select
              styles={{
                control: (baseStyles) => ({
                  ...baseStyles,
                  border: "1px solid #CBD5E1",
                  boxShadow: "0px 4px 3px rgba(232, 237, 242, 0.65)",
                  borderRadius: "8px",
                  padding: "5px",
                }),
              }}
              components={{
                IndicatorSeparator: () => null,
              }}
              placeholder="Assessment"
              name="assessments"
              classNamePrefix="select"
              options={assesmentsToSelect}
              value={selectedAssessment}
              onChange={(e) => {
                setSelectedAssessment(e);
              }}
              defaultValue={assesmentsToSelect[0]}
            />
          </div>
        )}

        {showCareGiverFilter &&
          process.env.REACT_APP_DASHBOARD_TYPE === "youth" && (
            <div style={{ width: "15%" }}>
              <Select
                styles={{
                  control: (baseStyles) => ({
                    ...baseStyles,
                    border: "1px solid #CBD5E1",
                    boxShadow: "0px 4px 3px rgba(232, 237, 242, 0.65)",
                    borderRadius: "8px",
                    padding: "5px",
                  }),
                }}
                components={{
                  IndicatorSeparator: () => null,
                }}
                placeholder="All"
                classNamePrefix="select"
                value={selectedCareGiver}
                onChange={(e) => {
                  setSelectedCareGiver(e);
                }}
                options={careGiverOptions}
              />
            </div>
          )}

        {showBillingNotes && (
          <div style={{ width: "15%" }}>
            <DatePicker
              placeholder="MMMM YYYY"
              appearance="subtle"
              name="billing_month"
              id="billing_month"
              format="MMMM yyyy"
              oneTap
              className="custom-datepicker"
              value={billingNotesFilter}
              onChange={(value) => {
                setSelectedMonth(value);
                
                  setBillingsFilter(value);
                
              }}
              required
            />
          </div>
        )}
      </div>
      
      {(showNotesDD || showBillingNotes) && (
        <button
          className="primary-btn-small-icon"
          onClick={() => {
            setNotesDownloadMode(true);
          }}
        >
          <ShareIcon /> Export Notes
        </button>
      )}
    </div>
  );
};

export default React.memo(FilteredComponent);
